import { generateUtilityClass, generateUtilityClasses, unstable_composeClasses as composeClasses } from '@mui/material';

export function getSubheaderUtilityClass(slot: string) {
  return generateUtilityClass('O2Subheader', slot);
}

const subheaderClasses = generateUtilityClasses('O2Subheader', [
  'root',
  'backlink',
  'content',
  'left',
  'title',
  'filters',
  'select',
  'switch',
  'description',
  'right',
  'custom-content',
  'tabs',
  'tab',
]);

export default subheaderClasses;

export const useSubheaderUtilityClasses = (classes?: Record<string, string>) => {
  return composeClasses(
    {
      root: ['root'],
      backlink: ['backlink'],
      content: ['content'],
      left: ['left'],
      title: ['title'],
      filters: ['filters'],
      select: ['select'],
      switch: ['switch'],
      description: ['description'],
      right: ['right'],
      'custom-content': ['custom-content'],
      tabs: ['tabs'],
      tab: ['tab'],
    },
    getSubheaderUtilityClass,
    classes
  );
};
